import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'src/@/components/ui/button';
import Iconify from 'src/components/Iconify';
import { CHAMADOS_DESIGN } from './Chamados.design';

const D = CHAMADOS_DESIGN.page;

const VIEWS = [
  { path: '/dashboard/chamados', label: 'Kanban', icon: 'mdi:view-dashboard' },
  { path: '/dashboard/meus-chamados', label: 'Lista', icon: 'mdi:format-list-bulleted' },
  { path: '/dashboard/chamados-chat', label: 'Detalhes', icon: 'mdi:view-column' },
];

export default function ChamadosHeader({ onCriarChamado }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={D.header.wrapper}>
      <div className={D.header.inner}>
        <div className={D.header.left}>
          <div className="flex items-center gap-2">
            <div className={D.header.iconBox}>
              <Iconify icon="mdi:ticket-confirmation" className={D.header.icon} width={20} />
            </div>
            <div>
              <h3 className={D.header.title}>Chamados</h3>
              <p className={D.header.subtitle}>Gerencie seus tickets e solicitacoes</p>
            </div>
          </div>

          <div className={D.header.divider} />

          <div className={D.viewToggle.container}>
            {VIEWS.map((view) => (
              <button
                key={view.path}
                onClick={() => navigate(view.path)}
                className={`${D.viewToggle.button.base} ${
                  location.pathname === view.path
                    ? D.viewToggle.button.active
                    : D.viewToggle.button.inactive
                }`}
                title={view.label}
              >
                <Iconify icon={view.icon} className={D.viewToggle.icon} width={14} />
                {view.label}
              </button>
            ))}
          </div>
        </div>

        <div className={D.header.right}>
          <Button onClick={onCriarChamado} className={D.actionButton}>
            <Iconify icon="mdi:plus" width={16} />
            Criar Chamado
          </Button>
        </div>
      </div>
    </div>
  );
}
